<div class="component-container">
  <mat-card>
    <mat-card-title>
      {{
        complete
          ? 'Connection Successful'
          : isValid
          ? 'Connect ' + agencyName
          : 'Invalid invitation, please contact customer support'
      }}
    </mat-card-title>

    <mat-card-header>
      <img mat-card-image src="../../assets/image/the-trade-desk.svg" alt="The Trade Desk Logo" />
    </mat-card-header>

    <mat-card-content *ngIf="isValid && !complete">
      <form #ttdForm="ngForm" fxLayout="column">
        <p>
          Enter your login credentials for The Trade Desk to generate an Api Key and associated it with
          {{ agencyName }}.
        </p>
        <mat-form-field fxFlex.xs="100%" fxFlex="70%">
          <input
            matInput
            type="email"
            placeholder="Email Address"
            [(ngModel)]="email"
            #em="ngModel"
            name="em"
            email
            required
          />
          <mat-error *ngIf="em.invalid && (em.touched || em.dirty)">
            <div *ngIf="em.errors.email && !em.errors.required">
              Enter a valid email address
            </div>
            <div *ngIf="em.errors.required">
              Email is required
            </div>
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex.xs="100%" fxFlex="70%">
          <input
            matInput
            #pw="ngModel"
            placeholder="Password"
            [(ngModel)]="password"
            name="password"
            type="password"
            required
          />
        </mat-form-field>
        <mat-error *ngIf="pw.invalid && (pw.touched || pw.dirty)">
          <div *ngIf="pw.errors.required">
            Password is required
          </div>
        </mat-error>

        <mat-error *ngIf="loginError">
          {{ loginError }}
        </mat-error>

        <mat-card-actions fxLayoutAlign="end end">
          <button
            mat-raised-button
            color="primary"
            class="mr-1"
            [disabled]="!ttdForm.form.valid"
            [appShowSpinner]="loading"
            [buttonText]="'Save'"
            (click)="ttdLogin($event)"
          >
            Save
          </button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
